export default __webpack_public_path__ + "static/media/paymentFailure.75b2248d.png";